export default __webpack_public_path__ + "static/media/related-post-06.b3d0ec7f.jpg";